"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var view_1 = require("../plot/view");
exports.ELEMENT_MAP = {}; // element 映射
/**
 * 根据类型获取 Element 类
 * @param type
 */
exports.getElement = function (type) {
    return exports.ELEMENT_MAP[type.toLowerCase()];
};
/**
 * 注册自定义 Element 类
 * @param type
 * @param ctor
 */
exports.registerElement = function (type, ctor) {
    // 注册的时候，需要校验 type 重名，不区分大小写
    if (exports.getElement(type)) {
        throw new Error("Element type '" + type + "' existed.");
    }
    var t = type.toLowerCase();
    // 存储到 map 中
    exports.ELEMENT_MAP[t] = ctor;
    view_1.registerViewPrototype(t, ctor);
};
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/factory.js
// module id = 596
// module chunks = 37